<template>
  <div class="evaluator">
    <div v-if="!showResult" class="desktopTitleWrapper">
      <div class="desktopTitle">ارزیابی قیمت ملک</div>
    </div>
    <div v-if="!showResult" class="evaluatorTitleWrapper">
      <div class="evaluatorTitle">ارزیابی قیمت ملک</div>
    </div>
    <div v-show="!showResult" class="evaluatorContainer">
      <form class="containerForm">
        <div class="formGroup thirdFlex">
          <label for="category" class="groupLabel">نوع ملک</label>
          <div class="gropuSelectWrapper">
            <div class="inputIcon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  d="M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z"
                />
                <path
                  d="m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z"
                />
              </svg>
            </div>
            <el-select
              ref="categorySelect"
              v-model="form.category"
              id="category"
              @change="getCategoryTitle"
              placeholder=""
            >
              <el-option label="آپارتمان" value="apartment" />
              <el-option label="اداری" value="Administrative" />
              <el-option label="خانه حیاط دار" value="villa_house" />
              <el-option label="ویلا" value="villa" />
              <el-option label="تجاری" value="commercial" />
              <el-option label="صنعتی" value="industrial" />
              <el-option label="باغ" value="garden" />
              <el-option label="زمین" value="land" />
            </el-select>
          </div>
        </div>
        <div class="formGroup thirdFlex">
          <label for="completion_date" class="groupLabel">سال ساخت</label>
          <div class="gropuSelectWrapper">
            <div class="inputIcon">
              <VsxIcon
                iconName="Calendar"
                :size="18"
                color="#0096c7"
                type="bold"
              />
            </div>
            <el-select
              v-model="form.completion_date"
              id="completion_date"
              placeholder=""
            >
              <el-option label="نوساز" value="new" />
              <el-option label="1 تا 5 سال" value="5" />
              <el-option label="5 تا 10 سال" value="10" />
              <el-option label="10 تا 15 سال" value="15" />
              <el-option label="بالای 15 سال" value="more" />
            </el-select>
          </div>
        </div>
        <div
          v-if="form.category != 'garden' && form.category != 'land'"
          class="formGroup thirdFlex"
        >
          <label for="building_area" class="groupLabel"
            >متراژ
            <span
              v-if="form.category == 'villa_house' || form.category == 'villa'"
              >بنا</span
            >
          </label>
          <div class="groupInputWrapper">
            <div class="inputIcon awesomeIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"
                />
              </svg>
            </div>
            <input
              v-model="front_show.building_area"
              @input="onAmountInput($event, 'building_area')"
              @keydown="onlyAllowNumbers"
              type="text"
              id="building_area"
              class="groupInput"
              inputmode="numeric"
            />
            <div class="inputUnit">متر</div>
          </div>
        </div>
        <div
          v-if="
            form.category === 'villa_house' ||
            form.category === 'garden' ||
            form.category === 'land'
          "
          class="formGroup thirdFlex"
        >
          <label for="land_area" class="groupLabel">متراژ زمین </label>
          <div class="groupInputWrapper">
            <div class="inputIcon awesomeIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  d="M32 32C14.3 32 0 46.3 0 64l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96z"
                />
              </svg>
            </div>
            <input
              v-model="front_show.land_area"
              @input="onAmountInput($event, 'land_area')"
              @keydown="onlyAllowNumbers"
              type="text"
              id="land_area"
              class="groupInput"
              inputmode="numeric"
            />
            <div class="inputUnit">متر</div>
          </div>
        </div>
        <div v-if="form.category == 'apartment'" class="formGroup thirdFlex">
          <label for="floor" class="groupLabel">طبقه</label>
          <div class="gropuSelectWrapper">
            <div class="inputIcon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.5 2.25a.75.75 0 0 0 0 1.5v16.5h-.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5h-.75V3.75a.75.75 0 0 0 0-1.5h-15ZM9 6a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm-.75 3.75A.75.75 0 0 1 9 9h1.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM9 12a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm3.75-5.25A.75.75 0 0 1 13.5 6H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM13.5 9a.75.75 0 0 0 0 1.5H15A.75.75 0 0 0 15 9h-1.5Zm-.75 3.75a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM9 19.5v-2.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75h-4.5A.75.75 0 0 1 9 19.5Z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <el-select v-model="form.floor" id="floor" placeholder="">
              <el-option
                v-for="i in 10"
                :key="i"
                :value="i"
                :label="`طبقه ${i}`"
              >
              </el-option>
              <el-option :value="11" :label="'بالاتر از طبقه 10'" />
            </el-select>
          </div>
        </div>
        <div
          v-if="
            form.category !== 'commercial' &&
            form.category !== 'industrial' &&
            form.category !== 'garden' &&
            form.category !== 'land'
          "
          class="formGroup thirdFlex"
        >
          <label for="bedroom" class="groupLabel">تعداد اتاق</label>
          <div class="gropuSelectWrapper">
            <div class="inputIcon awesomeIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                <path
                  d="M32 32c17.7 0 32 14.3 32 32l0 256 224 0 0-160c0-17.7 14.3-32 32-32l224 0c53 0 96 43 96 96l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-224 0-32 0L64 416l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                />
              </svg>
            </div>
            <el-select v-model="form.bedroom" id="bedroom" placeholder="">
              <el-option :value="0" :label="'بدون اتاق'" />
              <el-option
                v-for="i in 4"
                :key="i"
                :value="i"
                :label="`${i} اتاق`"
              />
              <el-option :value="5" :label="'بیش از 4 اتاق'" />
            </el-select>
          </div>
        </div>
        <div
          v-if="
            form.category !== 'commercial' &&
            form.category !== 'industrial' &&
            form.category !== 'garden' &&
            form.category !== 'land'
          "
          class="formGroup thirdFlex"
        >
          <label for="parking" class="groupLabel">پارکینگ</label>
          <div class="gropuSelectWrapper">
            <div class="inputIcon awesomeIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM192 256l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0 64zm48 64l-48 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-120c0-22.1 17.9-40 40-40l72 0c53 0 96 43 96 96s-43 96-96 96z"
                />
              </svg>
            </div>
            <el-select v-model="form.parking" id="parking" placeholder="">
              <el-option value="yes" label="دارد" />
              <el-option value="no" label="ندارد" />
            </el-select>
          </div>
        </div>
        <div
          v-if="
            form.category !== 'villa_house' &&
            form.category !== 'commercial' &&
            form.category !== 'industrial' &&
            form.category !== 'land' &&
            form.category !== 'garden'
          "
          class="formGroup thirdFlex"
        >
          <label for="elevator" class="groupLabel">آسانسور</label>
          <div class="gropuSelectWrapper">
            <div class="inputIcon awesomeIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l128 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 128zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-16zm192 0c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-16zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM356.7 91.3c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0L304 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"
                />
              </svg>
            </div>
            <el-select v-model="form.elevator" id="elevator" placeholder="">
              <el-option value="yes" label="دارد" />
              <el-option value="no" label="ندارد" />
            </el-select>
          </div>
        </div>
        <div
          v-if="
            form.category !== 'villa_house' &&
            form.category !== 'commercial' &&
            form.category !== 'industrial' &&
            form.category !== 'land' &&
            form.category !== 'garden'
          "
          class="formGroup thirdFlex"
        >
          <label for="doc_type" class="groupLabel">سند</label>
          <div class="gropuSelectWrapper">
            <div class="inputIcon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625ZM7.5 15a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7.5 15Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H8.25Z"
                  clip-rule="evenodd"
                />
                <path
                  d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z"
                />
              </svg>
            </div>
            <el-select v-model="form.doc_type" id="doc_type" placeholder="">
              <el-option
                v-for="(v, i) in $store.state.c_set.doc_type"
                :key="i"
                :value="i"
                :label="v"
              />
            </el-select>
          </div>
        </div>
        <!-- <div
          v-if="
            form.category !== 'commercial' &&
            form.category !== 'industrial' &&
            form.category !== 'land' &&
            form.category !== 'garden'
          "
          class="formGroup thirdFlex"
        >
          <label for="facade" class="groupLabel">نوع نما</label>
          <div class="gropuSelectWrapper">
            <div class="inputIcon awesomeIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                <path
                  d="M480 48c0-26.5-21.5-48-48-48L336 0c-26.5 0-48 21.5-48 48l0 48-64 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-64 0 0-72c0-13.3-10.7-24-24-24S64 10.7 64 24l0 72L48 96C21.5 96 0 117.5 0 144l0 96L0 464c0 26.5 21.5 48 48 48l256 0 32 0 96 0 160 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-112 0 0-144zm96 320l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM240 416l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zM560 256c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zM256 176l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zM256 304c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zM112 320l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zm304-48l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zm16 112l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16z"
                />
              </svg>
            </div>
            <el-autocomplete
              v-model="form.facade"
              id="facade"
              :fetch-suggestions="facadeQuerySearch"
              placeholder=""
            />
          </div>
        </div>
        <div
          v-if="
            form.category !== 'commercial' &&
            form.category !== 'industrial' &&
            form.category !== 'land' &&
            form.category !== 'garden'
          "
          class="formGroup thirdFlex"
        >
          <label for="flooring" class="groupLabel">نوع کفپوش</label>
          <div class="gropuSelectWrapper">
            <div class="inputIcon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  d="M11.644 1.59a.75.75 0 0 1 .712 0l9.75 5.25a.75.75 0 0 1 0 1.32l-9.75 5.25a.75.75 0 0 1-.712 0l-9.75-5.25a.75.75 0 0 1 0-1.32l9.75-5.25Z"
                />
                <path
                  d="m3.265 10.602 7.668 4.129a2.25 2.25 0 0 0 2.134 0l7.668-4.13 1.37.739a.75.75 0 0 1 0 1.32l-9.75 5.25a.75.75 0 0 1-.71 0l-9.75-5.25a.75.75 0 0 1 0-1.32l1.37-.738Z"
                />
                <path
                  d="m10.933 19.231-7.668-4.13-1.37.739a.75.75 0 0 0 0 1.32l9.75 5.25c.221.12.489.12.71 0l9.75-5.25a.75.75 0 0 0 0-1.32l-1.37-.738-7.668 4.13a2.25 2.25 0 0 1-2.134-.001Z"
                />
              </svg>
            </div>
            <el-autocomplete
              v-model="form.flooring"
              id="flooring"
              :fetch-suggestions="flooringQuerySearch"
              placeholder=""
            />
          </div>
        </div> -->
        <div class="formMapGroup">
          <label class="groupLabel">موقعیت مکانی</label>
          <div class="groupMap">
            <div id="map" style="height: 500px"></div>
          </div>
          <div class="formMapGroupWrapper">
            <div class="groupInput">
              <div class="inputIcon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="size-6"
                >
                  <path
                    fill-rule="evenodd"
                    d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <input
                type="search"
                v-model="address"
                placeholder="آدرس را وارد کنید"
                @keyup.enter="searchAddress"
                class="mapInput"
                enterkeyhint="search"
              />
            </div>
            <div class="groupBtns">
              <div
                v-if="!isLoading"
                class="showResultBtn"
                @click="submitDataHandler"
              >
                ارزیابی قیمت
              </div>
              <div v-else class="showResultBtn">
                <span class="evaluator-loader"></span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div v-show="showResult">
      <div v-show="result" class="evaluatorResultContainer">
        <div class="propertyInfoBox">
          <div class="infoColumn">
            <div class="propertyTitle">
              {{ categoryTitle }} {{ form.building_area }} متری
            </div>
            <div class="propertyAddress">
              <span>{{ address }}</span>
            </div>
            <div class="propertyFeaturesList">
              <div class="fueatureThumb">{{ categoryTitle }}</div>
              <div
                v-if="
                  form.category !== 'commercial' &&
                  form.category !== 'industrial' &&
                  form.category !== 'garden' &&
                  form.category !== 'land'
                "
                class="fueatureThumb"
              >
                {{ form.bedroom }} خواب
              </div>
              <div v-if="form.category == 'apartment'" class="fueatureThumb">
                طبقه {{ form.floor }}
              </div>
              <div
                v-if="
                  form.category !== 'villa_house' &&
                  form.category !== 'commercial' &&
                  form.category !== 'industrial' &&
                  form.category !== 'land' &&
                  form.category !== 'garden' &&
                  form.evaluator
                "
                class="fueatureThumb"
              >
                آسانسور
              </div>
              <div
                v-if="
                  form.category !== 'commercial' &&
                  form.category !== 'industrial' &&
                  form.category !== 'garden' &&
                  form.category !== 'land' &&
                  form.parking
                "
                class="fueatureThumb"
              >
                پارکینگ
              </div>
            </div>
          </div>
          <div class="setColumn">
            <div class="setBtn" @click="shareContent">
              <div class="btnIcon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path
                    d="M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
                  />
                </svg>
              </div>
            </div>
            <div class="setBtn" @click="generatePDF">
              <div class="btnIcon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div v-if="result" class="propertyPriceResult">
          <div class="priceResultThumb">
            <div class="thumbTitle">قیمت هر متر مربع</div>
            <div class="thumbPrice">
              <div class="priceNum">
                {{ formatNumberWithCommas(result.avg_meter_price) }}
              </div>
              <div class="priceUnit">تومان</div>
            </div>
          </div>
          <div class="priceResultThumb">
            <div class="thumbTitle">ارزش کلی ملک</div>
            <div class="thumbPrice">
              <div class="priceNum">
                {{ formatNumberWithCommas(result.arzesh_koli_build) }}
              </div>
              <div class="priceUnit">تومان</div>
            </div>
          </div>
          <div class="priceResultThumb">
            <div class="thumbTitle">بازه قیمت مشابه</div>
            <div class="thumbPrice">
              <div class="priceNum">{{ result.range }}</div>
              <!-- <div class="priceUnit">میلیون</div> -->
            </div>
          </div>
          <div class="priceResultThumb">
            <div class="thumbTitle">تعداد آگهی های مشابه</div>
            <div class="thumbPrice">
              <div class="priceNum">{{ result.total_same }}</div>
              <div class="priceUnit"></div>
            </div>
          </div>
        </div>
        <div class="propertyComparingChart">
          <div class="chartTitle">مقایسه با ملک‌های مشابه</div>
          <div class="chartContainer">
            <div ref="chartContainer" class="priceChart"></div>
          </div>
        </div>
        <div class="propertyComparingChart propertyMap">
          <div class="chartTitle">املاک اطراف</div>
          <div class="mapContainer">
            <div id="nearbyMap" style="height: 300px; width: 100%"></div>
          </div>
        </div>
        <div
          v-if="result && result.list && result.list.length > 0"
          class="suggestionList"
        >
          <div class="suggestionListTitle">
            <div class="listTitle">آگهی‌های مشابه</div>
            <div class="listNavigation">
              <div class="customNav prevBtn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m8.25 4.5 7.5 7.5-7.5 7.5"
                  />
                </svg>
              </div>
              <div class="customNav nextBtn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15.75 19.5 8.25 12l7.5-7.5"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="suggestionListWrapper">
            <Swiper
              :slides-per-view="'auto'"
              :space-between="20"
              :modules="modules"
              :navigation="{
                nextEl: '.nextBtn',
                prevEl: '.prevBtn',
              }"
            >
              <SwiperSlide v-for="(v, i) in result.list" :key="i">
                <div class="propertyThumb" @click="showPost(v)">
                  <div class="propertyPic">
                    <img :src="v.avatar" />
                  </div>
                  <div class="propertyContent">
                    <div class="contanteHeader">
                      <div class="propertyCategory">
                        {{ v.main_category }} - {{ v.category }}
                      </div>
                      <div class="propertyUpload">
                        <div class="propertyUploadIcon">
                          <VsxIcon
                            iconName="Calendar"
                            :size="14"
                            color="#0096c7"
                            type="linear"
                          />
                        </div>
                        <div class="propertyUploadTitle">
                          {{ v.created_fa }}
                        </div>
                      </div>
                    </div>
                    <div class="contentMain">
                      <div class="propertyTitle">{{ v.content }}</div>
                      <div class="propertyLocation">
                        <div class="locationIcon">
                          <i class="fa-solid fa-location-dot"></i>
                        </div>
                        <div class="locationTitle">
                          {{ v.address }}
                        </div>
                      </div>
                      <div class="contentPriceWrapper">
                        <div class="priceWrapper">
                          <div class="pricecTitle">قیمت :</div>
                          <div class="priceValue">{{ v.total_price }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
        <div class="calculatorSetBtns">
          <div class="setBtnThumb" @click="shareContent">
            <div class="thumbIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  d="M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
                />
              </svg>
            </div>
            <div class="thumbContent">
              <div class="contentTitle">اشتراک گذاری</div>
              <div class="contentSubtitle">با دوستانتان به اشتراک بگذارید</div>
            </div>
            <div class="thumbArrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
          <div class="setBtnThumb" @click="generatePDF">
            <div class="thumbIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                />
              </svg>
            </div>
            <div class="thumbContent">
              <div class="contentTitle">دانلود PDF</div>
              <div class="contentSubtitle">ذخیره نتایج محاسبات</div>
            </div>
            <div class="thumbArrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <router-link to="/home" class="showResultBtn"
          >بازگشت به صفحه اصلی</router-link
        >
      </div>
      <div v-if="!result" class="noResultWrapper">
        <div class="noResultThumb">
          <div class="thumbPic">
            <img src="/img/notfound.png"/>
          </div>
          <div class="thumbContent">
            داده ای یافت نشد!
          </div>
        </div>
        <router-link to="/home" class="showResultBtn"
          >بازگشت به صفحه اصلی</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import * as echarts from "echarts";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css";
import { Share } from "@capacitor/share";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import iranyekanFontBase64 from "../assets/fonts/iranyekan64"; // فرض بر اینه که فونت به صورت Base64 موجوده
// import logoBase64 from "../assets/img/logo64";
// import { File } from "@awesome-cordova-plugins/file";
// import { FileOpener } from "@awesome-cordova-plugins/file-opener";
// import { Capacitor } from "@capacitor/core";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: new URL(
    "leaflet/dist/images/marker-icon-2x.png",
    import.meta.url
  ).href,
  iconUrl: new URL("leaflet/dist/images/marker-icon.png", import.meta.url).href,
  shadowUrl: new URL("leaflet/dist/images/marker-shadow.png", import.meta.url)
    .href,
});

export default {
  name: "PropertyEvaluation",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      form: {
        category: "apartment",
        completion_date: "",
        building_area: 0,
        land_area: 0,
        floor: "",
        bedroom: "",
        parking: "",
        elevator: "",
        doc_type: "",
        facade: "",
        flooring: "",
        lat: "",
        lng: "",
      },
      front_show: {
        building_area: "",
        land_area: "",
      },
      result: null,
      facaedOptions: ["سنگ", "سرامیک", "سیمان"],
      flooringOptions: ["پارکت", "سرامیک", "موکت"],
      zoom: 13,
      center: [36.5513, 52.6789],
      marker: null,
      address: "",
      originalAddress: "",
      showResult: false,
      chartContainer: null,
      nearbyZoom: 19,
      nearbyCenter: [36.5513, 52.6789],
      modules: [Navigation],
      nearbyProperties: [
        {
          name: "آپارتمان 100 متری شهرک مخابرات",
          price: "3,800,000,000 ",
          coords: [36.5515, 52.6792],
        },
        {
          name: "ویلا 150 متری حمزه کلا",
          price: "5,200,000,000 ",
          coords: [36.5508, 52.6785],
        },
        {
          name: "آپارتمان 90 متری خیابان اصلی",
          price: "3,200,000,000 ",
          coords: [36.552, 52.68],
        },
        {
          name: "خانه حیاط‌دار 120 متری",
          price: "4,000,000,000 ",
          coords: [36.551, 52.6778],
        },
      ],
      map: null,
      nearbyMap: null,
      mapMarker: null,
      isLoading: false,
      categoryTitle: "",
      categoryOptions: [
        { label: "آپارتمان", value: "apartment" },
        { label: "اداری", value: "Administrative" },
        { label: "خانه حیاط دار", value: "villa_house" },
        { label: "ویلا", value: "villa" },
        { label: "تجاری", value: "commercial" },
        { label: "صنعتی", value: "industrial" },
        { label: "باغ", value: "garden" },
        { label: "زمین", value: "land" },
      ],
    };
  },
  watch: {
    "$route.params.result": {
      handler(newVal) {
        if (newVal == "result") {
          this.showResult = true;
        } else {
          this.showResult = false;

          this.form = {
            category: "",
            completion_date: "",
            building_area: 0,
            land_area: 0,
            floor: "",
            bedroom: "",
            parking: "",
            elevator: "",
            doc_type: "",
            facade: "",
            flooring: "",
            lat: "",
            lng: "",
          };
          this.front_show = {
            building_area: "",
            land_area: "",
          };
          this.result = null;
          this.marker = null;
          this.mapMarker && this.map.removeLayer(this.mapMarker);
          this.mapMarker = null;
          this.address = "";
          this.originalAddress = "";
          this.showResult = false;
        }
      },
    },
    result(newVal) {
      if (newVal) {
        this.getCategoryTitle(this.form.category);
        this.$nextTick(() => {
          setTimeout(() => {
            this.initPriceChart();
            this.initNearbyMap();
          }, 100);
        });
      }
    },
  },
  methods: {
    getCategoryTitle(value) {
      const selected = this.categoryOptions.find(
        (option) => option.value === value
      );
      this.categoryTitle = selected ? selected.label : "";
      console.log("titiititiit", this.categoryTitle);
    },
    initMainMap() {
      // Initialize the main map
      this.map = L.map("map", {
        center: this.center,
        zoom: this.zoom,
      });

      // Add tile layer
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(this.map);

      // Add click event to place marker
      this.map.on("click", (e) => {
        const { lat, lng } = e.latlng;
        this.onMapClick({ latlng: { lat, lng } });
      });

      // Update marker if it exists
      if (this.marker) {
        this.mapMarker = L.marker(this.marker).addTo(this.map);
      }
    },
    initNearbyMap() {
      const container = document.getElementById("nearbyMap");
      if (!container) {
        console.warn("nearbyMap container not found");
        return;
      }

      // تخریب نقشه قبلی اگه وجود داره
      if (this.nearbyMap) {
        this.nearbyMap.remove();
        this.nearbyMap = null;
      }

      const coordsList = (this.result?.list || [])
        .filter((p) => p.lat && p.lng)
        .map((p) => [p.lat, p.lng]);

      if (coordsList.length === 0) {
        console.warn("No coordinates to show on nearby map");
        return;
      }

      // ایجاد نقشه
      this.nearbyMap = L.map(container, {
        center: coordsList[0],
        zoom: this.nearbyZoom,
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(this.nearbyMap);

      // افزودن markerها
      coordsList.forEach((coords, index) => {
        const property = this.result.list[index];
        const marker = L.marker(coords).addTo(this.nearbyMap);
        marker
          .bindPopup(
            `
        <div class="marker-popup">
          <img src="${property.avatar}" style="width: 100px; height: 100px; object-fit: cover;">
          <div class="marker-popup-content">
            <h4>${property.content}</h4>
            <p>قیمت: ${property.total_price}</p>
            <p>${property.main_category} - ${property.category}</p>
          </div>
        </div>
      `
          )
          .on("mouseover", () => marker.openPopup())
          .on("mouseout", () => marker.closePopup());
      });

      // تنظیم مرکز خودکار
      this.nearbyMap.fitBounds(L.latLngBounds(coordsList), {
        padding: [20, 20],
      });

      // رفع مشکل نمایش با resize
      setTimeout(() => {
        this.nearbyMap.invalidateSize();
      }, 300);
    },
    showResultHandler() {
      this.$router.push("/property-evaluator/result");
      this.$nextTick(() => {
        document.documentElement.scrollTo({
          top: 0,
          behavior: "instant",
        });
      });
    },
    submitDataHandler() {
      if (!this.formValidation()) {
        document.documentElement.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      }

      this.isLoading = true;
      this.helperPost("get-property-evaluator", this.form).then((response) => {
        if (response.data.result == "1") {
          if (response.data.data.length == 0) {
            this.result = null;
          } else {
            this.result = response.data.data;
          }
          this.showResultHandler();
        }
        this.isLoading = false;
      });
    },
    facadeQuerySearch(queryString, cb) {
      const results = queryString
        ? this.facaedOptions.filter((facade) => facade.includes(queryString))
        : this.facaedOptions;
      cb(results.map((facade) => ({ value: facade })));
    },
    flooringQuerySearch(queryString, cb) {
      const results = queryString
        ? this.flooringOptions.filter((flooring) =>
            flooring.includes(queryString)
          )
        : this.flooringOptions;
      cb(results.map((flooring) => ({ value: flooring })));
    },
    onMapClick(e) {
      const { lat, lng } = e.latlng;
      this.marker = [lat, lng];
      this.form.lat = lat;
      this.form.lng = lng;
      console.log("latlng", this.form.lat);
      console.log("latlng", this.form.lng);

      // Remove existing marker if present
      if (this.mapMarker) {
        this.map.removeLayer(this.mapMarker);
      }

      // Add new marker
      this.mapMarker = L.marker([lat, lng]).addTo(this.map);
    },
    async updateAddress(lat, lng) {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&accept-language=fa`
        );
        const data = await response.json();

        let persianAddress = "";

        if (data.address) {
          const addressComponents = [
            data.address.state,
            data.address.city || data.address.town || data.address.village,
            data.address.suburb || data.address.neighbourhood,
            data.address.road,
          ];

          persianAddress = addressComponents.filter((part) => part).join("، ");
        }

        this.address = persianAddress || "آدرس نامشخص";
      } catch (error) {
        console.error("خطا در دریافت آدرس:", error);
        this.address = "خطا در دریافت آدرس";
      }
    },
    async searchAddress() {
      if (!this.address) {
        this.marker = null;
        if (this.mapMarker) {
          this.map.removeLayer(this.mapMarker);
          this.mapMarker = null;
        }
        return;
      }

      this.originalAddress = this.address;

      try {
        let response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
            this.address
          )}&accept-language=fa`
        );
        let data = await response.json();

        if (!data || data.length === 0) {
          const simplifiedAddress = this.address
            .split("،")
            .slice(0, 2)
            .join("،");
          response = await fetch(
            `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
              simplifiedAddress
            )}&accept-language=fa`
          );
          data = await response.json();
        }

        if (data && data.length > 0) {
          const { lat, lon } = data[0];
          this.marker = [parseFloat(lat), parseFloat(lon)];
          this.center = [parseFloat(lat), parseFloat(lon)];

          // Update map view
          this.map.setView(this.center, this.zoom);

          // Update marker
          if (this.mapMarker) {
            this.map.removeLayer(this.mapMarker);
          }
          this.mapMarker = L.marker(this.marker).addTo(this.map);

          await this.updateAddress(parseFloat(lat), parseFloat(lon));

          if (
            this.address !== this.originalAddress &&
            this.originalAddress.includes("،")
          ) {
            this.address = this.originalAddress;
          }
        } else {
          this.marker = null;
          if (this.mapMarker) {
            this.map.removeLayer(this.mapMarker);
            this.mapMarker = null;
          }
        }
      } catch (error) {
        console.error("خطا در جستجوی آدرس:", error);
        alert("خطا در جستجوی آدرس. لطفاً دوباره امتحان کنید.");
      }
    },
    initPriceChart() {
      if (this.$refs.chartContainer) {
        const priceChart = echarts.init(this.$refs.chartContainer);
        const priceChartOption = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
            formatter: "{b}<br/>{a0}: {c0} میلیون تومان",
            textStyle: {
              fontFamily: "iranyekan, sans-serif",
            },
          },
          grid: {
            top: "10%",
            left: "3%",
            right: "3%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            data: ["ملک شما", "حداکثر قیمت ", "حداقل قیمت"],
            axisLabel: {
              interval: 0,
              rotate: 0,
              fontFamily: "iranyekan, sans-serif",
              color: "#666",
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: {
            type: "value",
            name: "میلیون تومان",
            nameTextStyle: {
              fontFamily: "iranyekan, sans-serif",
              padding: [0, 0, 0, 50],
            },
            axisLabel: {
              fontFamily: "iranyekan, sans-serif",
              color: "#666",
            },
            splitLine: {
              lineStyle: {
                color: "#f0f0f0",
              },
            },
          },
          series: [
            {
              name: "قیمت",
              type: "bar",
              barWidth: "40%",
              data: [
                {
                  value:
                    this.result && this.result.avg_meter_price
                      ? this.result.avg_meter_price
                      : 0,
                  itemStyle: {
                    color: "#0096c7",
                    borderRadius: [8, 8, 0, 0],
                  },
                },
                {
                  value:
                    this.result && this.result.max_price
                      ? this.result.max_price
                      : 0,
                  itemStyle: {
                    color: "#90e0ef",
                    borderRadius: [8, 8, 0, 0],
                  },
                },
                {
                  value:
                    this.result && this.result.min_price
                      ? this.result.min_price
                      : 0,
                  itemStyle: {
                    color: "#ade8f4",
                    borderRadius: [8, 8, 0, 0],
                  },
                },
              ],
              emphasis: {
                itemStyle: {
                  color: "#0077b6",
                },
              },
            },
          ],
        };
        priceChart.setOption(priceChartOption);
        // Handle resize
        window.addEventListener("resize", () => {
          priceChart.resize();
        });
      }
    },
    onAmountInput(event, field) {
      const el = event.target;
      const raw = el.value.replace(/[^0-9]/g, "");

      const oldLength = el.value.length;
      const oldCursor = el.selectionStart;

      this.form[field] = raw;
      this.front_show[field] = this.formatWithCommas(raw);

      this.$nextTick(() => {
        const newLength = this.front_show[field].length;
        const diff = newLength - oldLength;
        el.setSelectionRange(oldCursor + diff, oldCursor + diff);
      });
    },
    onlyAllowNumbers(e) {
      const allowed = ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"];

      if (e.ctrlKey || e.metaKey) return;

      if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
        e.preventDefault();
      }
    },
    formatWithCommas(value) {
      if (!value) return "";
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatNumberWithCommas(number) {
      if (number === null || number === undefined) return "";

      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async generatePDF() {
      // const doc = new jsPDF({
      //   orientation: "portrait",
      //   unit: "mm",
      //   format: "a5",
      // });

      // // فونت
      // doc.addFileToVFS("IRANYekan.ttf", iranyekanFontBase64);
      // doc.addFont("IRANYekan.ttf", "IRANYekan", "normal");
      // doc.setFont("IRANYekan");

      // const pageWidth = doc.internal.pageSize.getWidth();
      // // عنوان

      // doc.addImage(logoBase64, "PNG", (pageWidth - 30) / 2, 15, 30, 30);

      // doc.setFontSize(13);
      // doc.setTextColor(33, 33, 33);
      // doc.text("شمال املاک", pageWidth / 2, 54, { align: "center" });

      // doc.setFontSize(15);
      // doc.setTextColor(33, 33, 33);
      // doc.text("ارزیابی قیمت ملک", pageWidth / 2, 62, { align: "center" });

      // const rows = [];

      // rows.push([this.categoryTitle, "نوع ملک"]);
      // if (this.form.building_area)
      //   rows.push([this.front_show.building_area + " متر", "متراژ بنا"]);
      // if (this.form.land_area)
      //   rows.push([this.front_show.land_area + " متر", "متراژ زمین"]);
      // if (this.form.bedroom)
      //   rows.push([this.form.bedroom + " اتاق", "تعداد اتاق"]);
      // if (this.form.floor) rows.push(["طبقه " + this.form.floor, "طبقه"]);
      // if (this.form.elevator === "yes") rows.push(["دارد", "آسانسور"]);
      // if (this.form.parking === "yes") rows.push(["دارد", "پارکینگ"]);
      // if (this.address) rows.push([this.address, "آدرس"]);

      // if (this.result) {
      //   rows.push([
      //     this.formatNumberWithCommas(this.result.avg_meter_price) + " تومان",
      //     "قیمت هر متر",
      //   ]);
      //   rows.push([
      //     this.formatNumberWithCommas(this.result.arzesh_koli_build) + " تومان",
      //     "ارزش کل ملک",
      //   ]);
      //   rows.push([this.result.range, "بازه قیمت مشابه"]);
      // }

      // autoTable(doc, {
      //   startY: 70,
      //   head: [["مقدار", "عنوان"]],
      //   body: rows,
      //   styles: {
      //     font: "IRANYekan",
      //     fontSize: 9,
      //     halign: "right",
      //     cellPadding: 3,
      //   },
      //   headStyles: {
      //     fillColor: [0, 150, 200],
      //     textColor: [255, 255, 255],
      //     fontStyle: "normal",
      //   },
      //   alternateRowStyles: {
      //     fillColor: [245, 245, 245],
      //   },
      //   columnStyles: {
      //     0: { halign: "right" },
      //     1: { halign: "right" },
      //   },
      // });

      // // doc.save("property_evaluation.pdf");
      // const fileName = "property_evaluation.pdf";
      // const blob = doc.output("blob");

      // const isNative = Capacitor.isNativePlatform();

      // if (isNative) {
      //   try {
      //     window.resolveLocalFileSystemURL(
      //       File.externalRootDirectory + "Download/",
      //       function (dirEntry) {
      //         dirEntry.getFile(
      //           fileName,
      //           { create: true, exclusive: false },
      //           function (fileEntry) {
      //             fileEntry.createWriter(function (fileWriter) {
      //               fileWriter.onwriteend = async function () {
      //                 toast("فایل با موفقیت ذخیره شد", {
      //                   type: "success",
      //                 });
      //                 try {
      //                   await FileOpener.open(
      //                     File.externalRootDirectory + "Download/" + fileName,
      //                     "application/pdf"
      //                   );
      //                 } catch (openErr) {
      //                   console.error("خطا در باز کردن فایل:", openErr);
      //                   toast("باز کردن فایل با مشکل مواجه شد", {
      //                     type: "error",
      //                   });
      //                 }
      //               };
      //               fileWriter.onerror = function (err) {
      //                 console.error("خطا در نوشتن فایل:", err);
      //                 toast("خطا در نوشتن فایل", {
      //                   type: "error",
      //                 });
      //               };
      //               fileWriter.write(blob);
      //             });
      //           },
      //           function (err) {
      //             console.error("خطا در ساخت فایل:", err);
      //           }
      //         );
      //       },
      //       function (err) {
      //         console.error("خطا در دسترسی به مسیر:", err);
      //       }
      //     );
      //   } catch (err) {
      //     console.error("خطا:", err);
      //     toast("خطای کلی در ذخیره فایل ", {
      //       type: "error",
      //     });
      //   }
      // } else {
      //   const url = URL.createObjectURL(blob);
      //   const link = document.createElement("a");
      //   link.href = url;
      //   link.download = fileName;
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      //   URL.revokeObjectURL(url);
      // }
      console.log("download")
    },
    getShareDataText() {
      const lines = [];
      const sep = ":\u200C ";

      lines.push("📊 نتیجه ارزیابی قیمت ملک:");
      lines.push(`نوع ملک${sep}${this.categoryTitle}`);

      if (this.form.building_area)
        lines.push(`متراژ بنا${sep}${this.front_show.building_area} متر`);
      if (this.form.land_area)
        lines.push(`متراژ زمین${sep}${this.front_show.land_area} متر`);
      if (this.form.bedroom) lines.push(`تعداد اتاق${sep}${this.form.bedroom}`);
      if (this.form.floor) lines.push(`طبقه${sep}${this.form.floor}`);
      if (this.form.elevator === "yes") lines.push(`آسانسور${sep}دارد`);
      if (this.form.parking === "yes") lines.push(`پارکینگ${sep}دارد`);

      if (this.address) lines.push(`آدرس${sep}${this.address}`);

      if (this.result) {
        lines.push(
          `قیمت هر متر${sep}${this.formatNumberWithCommas(
            this.result.avg_meter_price
          )} تومان`
        );
        lines.push(
          `ارزش کل ملک${sep}${this.formatNumberWithCommas(
            this.result.arzesh_koli_build
          )} تومان`
        );
        lines.push(`بازه قیمت مشابه${sep}${this.result.range}`);
      }

      lines.push("\n🔗 shomalamlak.ir/");
      return lines.join("\n");
    },
    async shareContent() {
      const textToShare = this.getShareDataText();

      if (this.$store.state.device === "Desktop") {
        if (navigator.clipboard && window.isSecureContext) {
          // استفاده از Clipboard API
          try {
            await navigator.clipboard.writeText(textToShare);
            toast("اطلاعات ارزیابی کپی شد.", {
              type: "success",
              dangerouslyHTMLString: true,
            });
          } catch (err) {
            console.error("کپی ناموفق:", err);
          }
        } else {
          // fallback با textarea
          const shareUrl = document.createElement("textarea");
          shareUrl.value = textToShare;
          document.body.appendChild(shareUrl);
          shareUrl.select();
          document.execCommand("copy");
          document.body.removeChild(shareUrl);

          toast("اطلاعات ارزیابی کپی شد.", {
            type: "success",
            dangerouslyHTMLString: true,
          });
        }
      } else {
        try {
          await Share.share({
            title: "اطلاعات ارزیابی ملک",
            text: textToShare,
            dialogTitle: "اشتراک‌گذاری با دوستان",
          });
        } catch (error) {
          console.error("خطا در اشتراک‌گذاری:", error);
        }
      }
    },
    handleBackToForm() {
      // پاک کردن همه مقادیر فرم
      this.form = {
        category: "apartment",
        completion_date: "",
        building_area: 0,
        land_area: 0,
        floor: "",
        bedroom: "",
        parking: "",
        elevator: "",
        doc_type: "",
        facade: "",
        flooring: "",
        lat: "",
        lng: "",
      };
      this.front_show = {
        building_area: "",
        land_area: "",
      };
      this.result = null;
      this.marker = null;
      this.mapMarker && this.map.removeLayer(this.mapMarker);
      this.mapMarker = null;
      this.address = "";
      this.originalAddress = "";
      this.showResult = false;

      // هدایت مسیر
      this.$router.replace("/property-evaluator");
    },
    handlePopState() {
      console.log("popstate");
      if (this.showResult) {
        this.handleBackToForm();
      }
    },
    formValidation() {
      if (this.form.category == "") {
        toast("نوع ملک خود را انتخاب کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return false;
      } else if (this.form.completion_date == "") {
        toast("سال ساخت را انتخاب کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return false;
      } else if (
        this.form.category != "garden" &&
        this.form.category != "land" &&
        this.form.building_area == 0
      ) {
        toast("متراژ ملک را وارد کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return false;
      } else if (
        (this.form.category === "villa_house" ||
          this.form.category === "garden" ||
          this.form.category === "land") &&
        this.form.land_area == 0
      ) {
        toast("متراژ ژمین را وارد کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return false;
      } else if (this.form.lat == "" && this.form.lng == "") {
        toast("موقعیت ملک را از روی نقشه انتخاب کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return false;
      } else {
        return true;
      }
    },
    showPost(ob) {
      const safeTitle = ob.content.replace(/\s+/g, "_");
      localStorage.removeItem("post_detail");
      this.$store.commit("post_detail_set", ob);
      this.$router.push(`/details/${ob.id}/${safeTitle}`);
    },
  },
  mounted() {
    this.initMainMap();
    if (this.$route?.params?.result == "result") {
      this.$router.push("/property-evaluator");
      this.$nextTick(() => {
        // Initialize nearby map when results are shown
        document.documentElement.scrollTo({
          top: 0,
          behavior: "instant",
        });
      });
    } else {
      this.showResult = false;
    }
    window.addEventListener("popstate", this.handlePopState);
  },
  beforeUnmount() {
    // Clean up maps to prevent memory leaks
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
    if (this.nearbyMap) {
      this.nearbyMap.remove();
      this.nearbyMap = null;
    }
    window.removeEventListener("popstate", this.handlePopState);
  },
};
</script>

<style lang="scss" scoped>
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
  appearance: none;
  display: none;
}

.evaluator {
  width: 90%;
  margin: 0 auto;
  padding-bottom: 32px;

  .desktopTitleWrapper {
    .desktopTitle {
      margin: auto;
      width: 90%;
      font-size: 25px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 1.5em;
      padding-bottom: 15px;
      position: relative;
      font-family: "iranyekanB";
      margin-top: 100px;
      margin-bottom: 38px;
      text-align: center;

      &::after {
        margin: auto;
        content: "";
        position: absolute;
        right: 0;
        left: 0;
        bottom: 0;
        height: 5px;
        width: 100px;
        background-color: #000000;
        border-radius: 5px;
      }

      &::before {
        margin: auto;
        content: "";
        position: absolute;
        right: 0;
        left: 0;
        bottom: 2px;
        height: 1px;
        width: 95%;
        max-width: 255px;
        background-color: #333;
      }
    }
  }

  .evaluatorTitleWrapper {
    display: none;
    width: 100%;
    text-align: center;
    margin-top: 18px;

    .evaluatorTitle {
      position: relative;
      font-family: "iranyekanB", sans-serif;
      font-size: 1.125rem;
      margin: 16px auto 12px;
      text-align: center;

      &::after,
      &::before {
        content: "";
        display: block;
        width: 76px;
        height: 1px;
        background: rgb(213, 213, 213);
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }

      &::after {
        left: 0;
      }

      &:before {
        right: 0;
      }
    }
  }

  .evaluatorContainer {
    padding-top: 16px;
    .containerForm {
      width: 98%;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: right;
      row-gap: 12px;
      column-gap: 2%;

      .formGroup {
        width: 100%;
        margin-bottom: 18px;

        &.thirdFlex {
          width: 31%;
        }

        .groupLabel {
          display: block;
          font-size: 0.95rem;
          margin-bottom: 8px;
          margin-right: 6px;
          opacity: 0.85;
        }

        :deep(.el-autocomplete .el-input .el-input__wrapper) {
          width: 100%;
          height: 47px !important;
          padding-right: 24px;
          border-radius: 5px !important;
          background: #fff !important;
          border: 1px solid rgb(209, 213, 219);
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          padding: 12px 32px 12px 12px !important;
          border-radius: 12px !important;
        }

        :deep(.el-select .el-select__wrapper) {
          width: 100%;
          height: 47px;
          padding-right: 24px;
          border-radius: 5px !important;
          background: #fff !important;
          border: 1px solid rgb(209, 213, 219);
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          padding: 12px 52px 12px 12px !important;
          border-radius: 12px !important;
        }

        :deep(.el-select__caret) {
          color: #0096c7 !important;
        }

        .groupInputWrapper {
          width: 100%;
          height: 47px;
          display: grid;
          grid-template-columns: 47px 1fr 47px;
          align-items: center;
          background: #fff !important;
          border: 1px solid rgb(209, 213, 219);
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          border-radius: 12px !important;

          .inputIcon {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0096c7;

            &.awesomeIcon {
              svg {
                width: 16px;
                height: 16px;
                fill: #0096c7;
              }
            }

            &::after {
              content: "";
              display: block;
              width: 32px;
              height: 32px;
              background: rgba(0, 150, 199, 0.1);
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              border-radius: 50%;
              z-index: 0;
            }

            svg {
              position: relative;
              z-index: 1;
              width: 24px;
              height: 24px;

              &.mortageIcon,
              &.rentIcon {
                width: 20px;
                height: 20px;
              }
            }
          }

          .inputUnit {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0096c7;
            font-size: 0.8rem;
          }

          .groupInput {
            width: 100%;
            height: 100%;
            border: none;
            box-shadow: none;
            border-radius: 0;
            text-align: center;
            font-size: 1rem;
          }
        }
        .gropuSelectWrapper {
          position: relative;

          .inputIcon {
            position: absolute;
            top: 50%;
            right: 14px;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0096c7;
            z-index: 1;

            &.awesomeIcon {
              svg {
                width: 16px;
                height: 16px;
                fill: #0096c7;
              }
            }

            &::after {
              content: "";
              display: block;
              width: 32px;
              height: 32px;
              background: rgba(0, 150, 199, 0.1);
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              border-radius: 50%;
              z-index: 0;
            }

            svg {
              position: relative;
              z-index: 1;
              width: 20px;
              height: 20px;
            }
          }
        }
      }

      .formMapGroupWrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .formMapGroup {
        width: 100%;
        margin-top: 0;

        .groupLabel {
          display: block;
          font-family: "iranyekanB", sans-serif;
          font-size: 1.25rem;
          margin-right: 12px;
          opacity: 0.85;
          margin-bottom: 16px;
        }

        .groupMap {
          width: 100%;
          margin-bottom: 20px;
          :deep(.leaflet-container) {
            width: 100%;
            height: auto !important;
            aspect-ratio: 7/2 !important;
            border: 1px solid #0096c7;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
            border-radius: 12px !important;
          }
        }

        .groupInput {
          width: 44%;
          height: 47px;
          display: grid;
          grid-template-columns: 47px 1fr;
          margin-top: 32px;
          align-items: center;
          background: #fff !important;
          border: 1px solid rgb(209, 213, 219);
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          border-radius: 12px !important;
          overflow: hidden;

          .inputIcon {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0096c7;
            z-index: 1;

            &.awesomeIcon {
              svg {
                width: 16px;
                height: 16px;
                fill: #0096c7;
              }
            }

            &::after {
              content: "";
              display: block;
              width: 32px;
              height: 32px;
              background: rgba(0, 150, 199, 0.1);
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              border-radius: 50%;
              z-index: 0;
            }

            svg {
              position: relative;
              z-index: 1;
              width: 20px;
              height: 20px;
            }
          }

          .mapInput {
            width: 100%;
            height: 100%;
            border: none;
            box-shadow: none;
            border-radius: 0;
            font-size: 0.9rem;
          }
        }
      }
    }
  }

  .evaluatorResultContainer {
    width: 100%;
    padding-top: 100px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;

    .propertyInfoBox {
      padding: 0 12px;
      width: 100%;
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .propertyTitle {
        font-family: "iranyekanB", sans-serif;
        font-size: 1.125rem;
        line-height: 1.75rem;
        margin-bottom: 4px;
      }
      .propertyAddress {
        font-size: 0.875rem;
        line-height: 1.25rem;
        color: #4b5563;
        margin-bottom: 8px;
      }

      .propertyFeaturesList {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        flex-wrap: wrap;

        .fueatureThumb {
          padding: 4px 10px;
          font-size: 0.75rem;
          line-height: 1rem;
          color: #0096c7;
          background: #dbeafe;
          border-radius: 9999px;
        }
      }

      .setColumn {
        display: flex;
        align-items: flex-start;
        gap: 16px;
        .setBtn {
          cursor: pointer;
          .btnIcon {
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 16px;
            width: 42px;
            height: 42px;
            background: #0096c7;

            svg {
              width: 18px;
              height: 18px;
              path {
                fill: #fff;
              }
            }
          }
        }
      }
    }

    .propertyPriceResult {
      width: 48%;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
      margin-bottom: 24px;

      .priceResultThumb {
        width: 100%;
        padding: 24px;
        background: #fff;
        box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
          0 2px 4px -2px rgb(0 0 0 / 0.1);
        border-radius: 8px;
        display: flex;
        flex-direction: column;

        .thumbTitle {
          font-size: 0.875rem;
          line-height: 1.25rem;
          color: #4b5563;
          margin-bottom: 4px;
        }

        .thumbPrice {
          display: flex;
          align-items: flex-end;
          gap: 4px;
          color: #0096c7;

          .priceNum {
            font-size: 1.125rem;
            line-height: 1.75rem;
            font-family: "iranyekanB", sans-serif;
          }

          .priceUnit {
            font-size: 0.75rem;
            margin-bottom: 4px;
          }
        }
      }
    }

    .propertyComparingChart {
      width: 48%;
      padding: 24px;
      background: #fff;
      box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
        0 2px 4px -2px rgb(0 0 0 / 0.1);
      border-radius: 8px;
      margin-bottom: 24px;

      &.propertyMap {
        width: 99%;
        margin-left: auto;
        margin-right: auto;
      }

      .chartTitle {
        font-family: "iranyekanB", sans-serif;
        font-size: 1.125rem;
        line-height: 1.75rem;
        margin-bottom: 24px;
      }

      .mapContainer {
        :deep(.leaflet-container) {
          width: 100%;
          aspect-ratio: 1;
          border: 1px solid #0096c7;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          border-radius: 12px !important;
        }

        :deep(.popup-wrapper) {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        :deep(.popup-pic) {
          flex-shrink: 0;
        }

        :deep(.popup-pic img) {
          width: 64px;
          height: 64px;
          object-fit: cover;
          border-radius: 4px;
        }

        :deep(.popup-content) {
          font-family: "iranyekan", sans-serif !important;
          text-align: right;
          padding: 8px;
        }
        :deep(.popup-content .popup-title) {
          font-size: 0.9rem;
          font-weight: bold;
          color: #1f2937;
          margin-bottom: 8px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        :deep(.popup-content .popup-price) {
          display: flex;
          align-items: flex-end;
          gap: 4px;
          font-family: "iranyekanB", sans-serif;
          font-size: 0.85rem;
          color: #0096c7;
        }
        :deep(.popup-content .popup-price .priceUnit) {
          margin-bottom: 4px;
          font-size: 0.75rem;
          font-family: "iranyekan", sans-serif;
        }
      }

      .chartContainer {
        width: 100%;
        height: 252px;

        .priceChart {
          width: 100%;
          height: 100%;
        }
      }
    }
    .suggestionList {
      margin-top: 24px;
      width: 100%;

      .suggestionListTitle {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .listTitle {
          font-family: "iranyekanB", sans-serif;
          font-size: 1.15rem !important;
        }

        .listNavigation {
          display: flex;
          align-items: center;
          gap: 8px;

          .customNav {
            width: 2.375rem;
            height: 2.375rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #d8d8d8;
            border-radius: 8px;
            cursor: pointer;

            &.swiper-button-disabled {
              opacity: 0.5;
              cursor: auto;
            }

            svg {
              width: 18px;
            }
          }
        }
      }

      .suggestionListWrapper {
        .swiper {
          padding: 0 16px;
          .swiper-wrapper {
            .swiper-slide {
              width: auto;
            }
          }
        }

        .propertyThumb {
          width: 280px;
          height: 100%;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
          margin: 16px 0;
          cursor: pointer;

          .propertyPic {
            position: relative;
            width: 100%;
            aspect-ratio: 3/2;

            .propertyNums {
              position: absolute;
              top: 8px;
              left: 8px;
              z-index: 1;
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 8px;

              & > div {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: row-reverse;
                height: 32px;
                padding: 0 6px;
                gap: 6px;
                background: rgba(0, 0, 0, 0.6);
                border-radius: 5px;

                .numsICON {
                  svg {
                    fill: #fff;
                    stroke: #fff;
                    width: 20px;
                    height: 20px;
                  }
                }

                .numNumber {
                  color: #f1f1f1;
                  font-size: 0.9rem;
                }
              }
            }

            img {
              position: relative;
              width: 100%;
              height: 100%;
              -o-object-fit: cover;
              object-fit: cover;
              z-index: 0;
            }
          }

          .propertyContent {
            padding: 12px;
            padding-bottom: 16px;

            .contanteHeader {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .propertyCategory {
                padding: 4px 8px;
                border-radius: 24px;
                background: #f7f7f7;
                font-size: 0.7rem;
                color: #0096c7;
              }

              .propertyUpload {
                padding: 4px 8px;
                border-radius: 24px;
                background: #f7f7f7;
                font-size: 0.7rem;
                display: flex;
                align-items: center;
                gap: 4px;

                .propertyUploadTitle {
                  height: 14px;
                  display: flex;
                  align-items: center;
                }
              }
            }

            .contentMain {
              .propertyTitle {
                font-family: "iranyekan", sans-serif;
                font-size: 1.075rem;
                margin-top: 14px;
                margin-bottom: 8px;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }

              .propertyLocation {
                display: flex !important;
                align-items: center;
                gap: 4px;
                color: #4b5563;
                font-size: 0.75rem;
                margin-bottom: 8px;

                .locationTitle {
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                }
              }

              .featuresThumb {
                padding: 4px 8px;
                font-size: 0.75rem;
                line-height: 1.25rem;
                display: flex !important;
                align-items: center !important;
                gap: 4px;
                border-radius: 24px;
                color: #fff;
                height: 21px;
                white-space: nowrap !important;

                &.request {
                  background: #00d084;
                }

                &.fast {
                  background: #ff6c00;
                }

                &.exchange {
                  background: #ff7f50;
                }

                &.single {
                  background: #1abc9c;
                }

                svg {
                  width: 13px;
                  height: 13px;
                }
              }

              .contentPriceWrapper {
                margin-bottom: 12px;
                min-height: none !important;

                .priceWrapper {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  gap: 6px;

                  .pricecTitle {
                    font-size: 0.85rem;
                    color: #4b5563;
                  }

                  .priceValue {
                    font-family: "iranyekanB", sans-serif;
                    font-size: 0.95rem;
                  }
                }
              }
            }
          }
        }
      }
    }
    .calculatorSetBtns {
      display: none;
      margin-top: 32px;
      .setBtnThumb {
        position: relative;
        padding: 1.25rem 1.5rem;
        background: linear-gradient(
          to right,
          rgba(0, 150, 199, 0.05),
          rgba(0, 180, 216, 0.05)
        );
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        gap: 16px;
        border-radius: 16px;
        cursor: pointer;

        &:hover {
          transform: scale(1.01);

          .thumbArrow {
            transform: translateX(-9px) translateY(-50%);
          }
        }

        &:first-of-type {
          margin-bottom: 24px;
        }

        .thumbIcon {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 16px;
          width: 42px;
          height: 42px;
          background: #0096c7;

          svg {
            width: 18px;
            height: 18px;
            path {
              fill: #fff;
            }
          }
        }

        .thumbContent {
          .contentTitle {
            color: #1f2937;
            font-size: 0.95rem;
            margin-bottom: 4px;
          }

          .contentSubtitle {
            font-size: 0.8rem;
            color: #6b7280;
          }
        }

        .thumbArrow {
          position: absolute;
          top: 50%;
          left: 16px;
          transform: translateY(-50%);

          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }

  .showResultBtn {
    width: 240px;
    height: 47px;
    background: linear-gradient(to right, #0096c7, #00b4d8);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    font-size: 0.95rem;
    border-radius: 12px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    margin-top: 32px;
    cursor: pointer;
  }
}

@media (min-width: 1000px) {
  .evaluator {
    .evaluatorResultContainer {
      .propertyPriceResult {
        .priceResultThumb {
          justify-content: center;

          .thumbTitle {
            font-size: 1rem;
          }

          .thumbPrice {
            .priceNum {
              font-size: 1.25rem;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .evaluator {
    padding-top: 0;
    .desktopTitleWrapper {
      display: none;
    }
    .evaluatorTitleWrapper {
      display: block;
    }

    .evaluatorContainer {
      .containerForm {
        row-gap: 0;
        .formGroup {
          &.thirdFlex {
            width: 100%;
          }
        }
        .formMapGroupWrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        }

        .formMapGroup {
          .groupLabel {
            font-family: "iranyekan", sans-serif;
            font-size: 1.05rem;
            margin-right: 6px;
            margin-bottom: 8px;
          }
          .groupMap {
            :deep(.leaflet-container) {
              aspect-ratio: 3/2 !important;
            }
          }
          .groupInput {
            width: 100%;
            margin-top: 0;
          }
        }
      }

      .groupBtns {
        width: 100%;
      }
      .showResultBtn {
        width: 100%;
      }
    }

    .evaluatorResultContainer {
      padding-top: 16px;
      display: block;

      .propertyInfoBox {
        padding: 0;
        .setColumn {
          display: none;
        }
      }

      .propertyPriceResult {
        width: 100%;
        gap: 16px;
      }

      .propertyComparingChart {
        width: 100%;
      }
    }

    .calculatorSetBtns {
      display: block !important;
    }

    .showResultBtn {
      width: 100%;
    }
  }

  .noResultWrapper {
    position: relative;
    height: 90vh;

    .noResultThumb {
      .thumbPic {
        img {
          width: 80%;
          display: block;
          margin-left: auto;
          margin-right: auto;
          margin-top: 24px;
        }
      }

      .thumbContent {
        text-align: center;
        font-size: 0.95rem;
      }
    }

    .showResultBtn {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
  }
}

.dark {
  .evaluator {
    color: #fff;
    .desktopTitleWrapper {
      .desktopTitle {
        &::after {
          background: #fff;
        }

        &::before {
          background: #ccc;
        }
      }
    }
    .evaluatorContainer {
      .containerForm {
        .formGroup {
          :deep(.el-autocomplete .el-input .el-input__wrapper),
          :deep(.el-select .el-select__wrapper) {
            box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
            border: 1px solid #2a3b47;
            background: #101a23 !important;
          }
          :deep(
              .el-select
                .el-select__wrapper
                .el-select__selection
                .el-select__placeholder
                span
            ) {
            color: #fff !important;
          }

          .groupInputWrapper {
            box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
            border: 1px solid #2a3b47;
            background: #101a23 !important;

            .groupInput {
              background: #101a23 !important;
            }
          }
        }
        .formMapGroup {
          .groupMap {
            :deep(.leaflet-container) {
              box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
            }
          }
          .groupInput {
            box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
            border: 1px solid #2a3b47;
            background: #101a23 !important;
            .mapInput {
              background: #101a23 !important;
            }
          }
        }
      }
    }
    .evaluatorResultContainer {
      .propertyInfoBox {
        .propertyAddress {
          color: #aab3c4;
        }
        .propertyFeaturesList {
          .fueatureThumb {
            background: #1d242c;
          }
        }
      }
      .propertyPriceResult {
        .priceResultThumb {
          background: #101a23;
          box-shadow: 0 4px 6px -1px rgba(255, 255, 255, 0.1),
            0 2px 4px -2px rgba(255, 255, 255, 0.1);

          .thumbTitle {
            color: #b0bacb;
          }
        }
      }
      .propertyComparingChart {
        background: #101a23;
        box-shadow: 0 4px 6px -1px rgba(255, 255, 255, 0.1),
          0 2px 4px -2px rgba(255, 255, 255, 0.1);

        .mapContainer {
          :deep(.leaflet-container) {
            width: 100%;
            aspect-ratio: 1;
            border: 1px solid #0096c7;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
            border-radius: 12px !important;
          }
          :deep(.popup-content .popup-title) {
            color: #9ba6b8;
          }
          :deep(.leaflet-popup-tip-container .leaflet-popup-tip) {
            background: #101a23 !important;
            box-shadow: 0 3px 14px rgba(255, 255, 255, 0.4) !important;
          }
        }
      }
      .suggestionList {
        .suggestionListWrapper {
          .propertyThumb {
            box-shadow: 0 0 6px rgba(255, 255, 255, 0.15);
            .propertyContent {
              .contanteHeader {
                .propertyCategory,
                .propertyUpload {
                  background: #2a2f33;
                }
              }
            }
          }
        }
      }
      .calculatorSetBtns {
        .setBtnThumb {
          box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
          .thumbContent {
            .contentTitle {
              color: #9ba6b8;
            }
            .contentSubtitle {
              color: #9ea4b2;
            }
          }
        }
      }
    }
  }
}

.evaluator-loader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.noResult {
  text-align: center;
  font-size: 1.25rem;
  font-weight: 700;
  text-align: center;
  padding: 120px 0;
}
</style>
